export default __webpack_public_path__ + "static/media/xblack.c357506c.svg";